"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LookupColumn;
    }
});
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let LookupColumn = class LookupColumn {
    async getRelationColumn(context) {
        return await _Column.default.get(context, {
            colId: this.fk_relation_column_id
        });
    }
    async getLookupColumn(context) {
        return await _Column.default.get(context, {
            colId: this.fk_lookup_column_id
        });
    }
    static async insert(context, data, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(data, [
            'fk_column_id',
            'fk_relation_column_id',
            'fk_lookup_column_id'
        ]);
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_LOOKUP, insertObj);
        return this.read(context, data.fk_column_id, ncMeta).then(async (lookupColumn)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.COL_LOOKUP, [
                data.fk_lookup_column_id
            ], `${_globals.CacheScope.COL_LOOKUP}:${data.fk_column_id}`);
            await _NocoCache.default.appendToList(context, _globals.CacheScope.COL_LOOKUP, [
                data.fk_relation_column_id
            ], `${_globals.CacheScope.COL_LOOKUP}:${data.fk_column_id}`);
            return lookupColumn;
        });
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let colData = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_LOOKUP}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!colData) {
            colData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_LOOKUP, {
                fk_column_id: columnId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_LOOKUP}:${columnId}`, colData);
        }
        return colData ? new LookupColumn(colData) : null;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
